<template>
  <div class="overflow-x-auto">
    <table class="w-full">
      <thead>
        <slot name="head"></slot>

        <tr>
          <td
            colspan="999"
            class="relative p-0"
          >
            <v-indeterminate-progress
              class="absolute -top-[1px] left-0 right-0 h-[2px]"
              :loading="props.loading"
            />
          </td>
        </tr>
      </thead>

      <v-tr v-if="isEmpty && (wasLoadedOnce || !props.loading)">
        <v-td colspan="999">
          <slot name="empty"> No entries found </slot>
        </v-td>
      </v-tr>

      <slot name="body"></slot>

      <slot />
    </table>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  loading?: boolean
}>()

const slots = useSlots()
const isEmpty = computed(() => {
  const bodySlot = slots.body
  if (!bodySlot) {
    return true
  }

  const nodes = bodySlot()
  return nodes.every(({ children }) => {
    const hasChildren = Array.isArray(children) && children.length
    const isRenderFn = children instanceof Object && "default" in children && children.default
    return !hasChildren && !isRenderFn
  })
})

const wasLoadedOnce = ref(false)
watchEffect(() => {
  if (!props.loading) {
    wasLoadedOnce.value = true
  }
})
</script>
